import React from "react";
import PropTypes from 'prop-types';
import _ from 'lodash';
// import {SortableContainer} from 'react-sortable-hoc';
import RoomItem from 'ui/components/roomItem';
import { isAlertOn } from 'modules/room';

class RoomList extends React.PureComponent {
  render() {
    const {
      items, marginRight, groupId,
      notifications, onRoomPress, families,
    } = this.props;
    return (
      <div className='roomListContainer'>
        {items.map((item, index) => (
          <RoomItem
            key={`room-${item.suiteId}`}
            index={index}
            styles={{ marginRight }}
            groupId={groupId}
            alert={isAlertOn(item.suiteId, notifications)}
            onRoomPress={onRoomPress}
            family={_.get(families, `[${item.suiteId}]`, {})}
            {...item}
          />
        ))}
      </div>
    );
  }
}


RoomList.defaultProps = {
  roomHeight: 150,
  roomWidth: 140,
  onRoomPress: null,
};

RoomList.propTypes = {
  items: PropTypes.array.isRequired,
  roomHeight: PropTypes.number,
  roomWidth: PropTypes.number,
  onSortEnd: PropTypes.func,
  axis: PropTypes.oneOf([
    'x',
    'y',
    'xy'
  ]).isRequired,
  marginRight: PropTypes.number.isRequired,
  groupId: PropTypes.string.isRequired,
  notifications: PropTypes.array.isRequired,
  onRoomPress: PropTypes.func,
  families: PropTypes.object.isRequired,
};

// export default SortableContainer(RoomList);
export default RoomList;

